import { Validators } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { regex } from '../../../../common/regex.constants';

export interface EmailModel {
  editValue: string;
}
export interface PlusModel {
  purpose: string;
  vin: string;
  guid: string;
  sendNotification: boolean;
}
export interface LegacyModel {
  role: string;
}

export class Email {
  /**
  *@property formBindings
  **/
  public formBindings: EmailModel;
  /**
*@property vin generation
**/
  public generation: string;
  /**
  *@property remote data
  **/
  public data: EmailModel;
  constructor(
    public updateDetails: any
  ) {
    this.data = { editValue: updateDetails['updateValue'] };
    this.generation = this.updateDetails.otherParams['generation'];
  }

  /**
  * @method __defaults Return the defaults values for the model
  * @returns All the values in the EmailModel interface as ''
  **/
  public __defaults(): EmailModel {
    return this.formBindings = {
      editValue: '',
    };
  }
  /**
  * @method values Return the values send in the data property
  * @returns SignUpModel Interface
  **/
  public get values(): EmailModel {
    return this.data !== undefined ? this.__formBindings({ ...this.data }) : this.__defaults();
  }
  /**
  * @method __formBindings Returns the values for initialize in case of read mode
  * @returns SignUpModel
  **/
  public __formBindings(bindings: EmailModel): EmailModel {
    return {
      'editValue': bindings['editValue'] ? bindings['editValue'] : '',
    };
  }
  /**
  * @function tag returns the translation tag for email address when called
  * @returns {string}
  **/
  public get tag(): string {
    return 'authorize-remote.label.email-address';
  }
  /**
  * @function auto_authorize returns the endpoint for autoauthorizing remoteuser 17cy+ vehicles
  * @returns {string}
  **/
  public get auto_authorize(): string {
    return this.generation === '17CYPLUS' || this.generation === '21MM' || this.generation === 'GR86' ? environment.admin.apis.subscription.auto_authorize : environment.admin.apis.subscription.auto_authorize_legacy;
  }
  /**
  * @function placeholder returns the translation for email address when called
  * @returns {string}
  **/
  get placeholder(): string {
    return this.tag;
  }
  /**
  * @function translateParams returns the object for email address context when called
  * @returns {object}
  **/
  get translateParams(): object {
    return { 'tag': 'Email Address' };
  }

  /**
  * @method form Return the form controls to be used in the update-account component
  * @returns Object with the controls
  **/
  public get form(): object {
    return this.customerControls;
  }
  /**
  * @method customerControls Controls for the remote view
  * @returns Object with the required controls
  **/
  public get customerControls(): object {
    return {
      editValue: this.emailControl,
    };
  }
  /**
  * @method emailControl Controls for email field
  * @returns Array of validators
  **/
  public get emailControl(): any[] {
    return [
      { value: '', disabled: true },
      [Validators.required,
      Validators.minLength(1),
      Validators.maxLength(64),
      Validators.pattern(regex.emailPattern)]
    ];
  }
  /**
  * @function fieldRequired returns the translation for required field validation error of email and code when called
  * @returns Array<string>
  **/
  public get fieldRequired(): Array<string> {
    return ['sign-up.errors.email-required', 'sign-up.errors.code-required'];
  }
  /**
  * @function fieldPattern returns the translation for Pattern validation error of email and code when called
  * @returns Array<string>
  **/
  public get fieldPattern(): Array<string> {
    return ['sign-up.validations.email-pattern', 'sign-up.validations.code-pattern'];
  }
  /**
  * @function fieldLength returns the translation for maxlength validation error of email and code when called
  * @returns Array<string>
  **/
  public get fieldLength(): Array<string> {
    return ['sign-up.validations.email-maxlength', 'sign-up.validations.code-maxlength'];
  }
  /**
  * @function getApiType returns the api type for remote api
  * @returns string
  **/
  public getApiParams(): object {
    return {
      type: this.generation === '17CYPLUS' || this.generation === '21MM' ? 'sendCode' : this.generation === 'GR86' ? 'subaru' : 'auth_remote_legacy',
      params: { guid: this.updateDetails['otherParams']['guid'], vin: this.updateDetails['otherParams']['vin'], 'brand': this.updateDetails['otherParams']['brand'] }
    };
  }
  /**
  * @method payload Return the payload object for remote update
  * @returns  PlusModel
  **/
  public apiPayload(): PlusModel | LegacyModel {
    return this.generation === '17CYPLUS' || this.generation === '21MM' || this.generation === 'GR86' ? {
      purpose: 'REMOTE_AUTHORIZATION',
      vin: this.updateDetails['otherParams']['vin'],
      guid: this.updateDetails['otherParams']['guid'],
      sendNotification: false
    } : { 'role': 'REMOTECMD_USER' };
  }
}

